(function () {
	let featuredCollectionSlide = () => {
		var $slickElement = $('.collection-product-list').not('.slick-initialized');

		$slickElement.slick({
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 3,
			variableWidth: true,
			arrows: false,
			dots: false,
			speed: 1000,
			responsive: [
				{
					breakpoint: 1331,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						speed: 500,
					},
				},
				{
					breakpoint: 990,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						speed: 500,
					},
				},
			],
		});

		$('.collection-product-list__button--next').click(function () {
			$(this)
				.parents('.collection-product__slider')
				.find('.collection-product-list')
				.slick('slickNext');
		});
		$('.collection-product-list__button--prev').click(function () {
			$(this)
				.parents('.collection-product__slider')
				.find('.collection-product-list')
				.slick('slickPrev');
		});
	};

	const calcHeight = () => {
		const card = document.querySelector('.featured-collection-section__card');
		const featuredcollectionSection = document.querySelector('.featured-collection-section');
		const cardRect = card.getBoundingClientRect();
		const cardHeight = cardRect.height;
		featuredcollectionSection.style.paddingBottom = `${cardHeight / 2}px`;
	};

	document.addEventListener('shopify:section:load', function () {
		featuredCollectionSlide();
		calcHeight();
	});

	featuredCollectionSlide();
	calcHeight();
})();
